<template>
  <div>
    <div class="l-row">
      <form-group :label="$t('brand.label')" :columns="6">
        <select v-model="filters.brand" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="brand in brands" :value="brand" :key="brand">{{ brand }}</option>
        </select>
      </form-group>

      <form-group :label="$t('category.label')" :columns="6">
        <select v-model="filters.category" class="form-select">
          <option :value=null>Todas</option>
          <option v-for="categorie in categories" :value="categorie" :key="categorie.value">{{ categorie.label }}</option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      brands: [],
      categories: [],
      filters: {
        brand: null,
        category: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      api.getBrands(this.module.type, this.module.identifier)
        .then(brands => { this.brands = brands })
        .catch(() => (this.brands = []))

      api.getCategories(this.module.type, this.module.identifier)
        .then(categories => { this.categories = categories })
        .catch(() => (this.categories = []))
    },
    components: {
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Colombo.vue?18d9a82f